import { goSolidApi } from "@/composables/useGoSolidApi";
import type { ActivityLogPage, ActivityLogQuery } from "./activityLogTypes";

/**
 * One page of the audit log, newest first. Axios sends `activity_keys` as repeated `activity_keys[]`,
 * the shape the route expects. Errors propagate to the caller.
 */
export async function listActivities(
  query: ActivityLogQuery,
  signal?: AbortSignal
): Promise<ActivityLogPage> {
  return (
    await goSolidApi.get<ActivityLogPage>("/api/admin/account/activities", {
      params: query,
      signal,
    })
  ).data;
}

/** Every activity kind the audit log records, for the type filter. */
export async function listActivityKeys(): Promise<string[]> {
  return (
    await goSolidApi.get<{ activity_keys: string[] }>(
      "/api/admin/account/activity-keys"
    )
  ).data.activity_keys;
}
